"use client";

import React from "react";

//Type
import { NotFoundProps } from "@/types";

//Styled
import * as S from "./styles";

//Icon
import { ServerOff } from "lucide-react";

const NotFound: React.FC<NotFoundProps> = ({
  className,
  title,
  description,
  children,
  icon,
  heightContain,
}) => {
  return (
    <S.Box className={className} $heightContain={heightContain}>
      {icon ? icon : <ServerOff />}
      <S.Text>{title}</S.Text>
      <S.Description>{description} </S.Description>
      {children}
    </S.Box>
  );
};

export default NotFound;
